import CorsErrorModal from './CorsErrorModal';

export default CorsErrorModal;
